import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { RegionSelector } from 'components/RegionSelector';
import { useNotifications } from 'features/notifications/hooks/useNotifications';
import { NotificationSetting } from 'features/notifications/notifications.types';

type NotificationSettingsRegionAddProps = {
  onboarding?: boolean;
};

type ContentProps = {
  regionSettings: NotificationSetting[];
  onboarding?: boolean;
};

export const Content = (props: ContentProps): JSX.Element => {
  const { regionSettings, onboarding } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('notificationSettingsRegionAdd.title')}</title>
      </Helmet>
      <RegionSelector regionSettings={regionSettings} onboarding={onboarding} />
    </>
  );
};

export const NotificationSettingsRegionAdd = (
  props: NotificationSettingsRegionAddProps,
): JSX.Element => {
  const { onboarding } = props;
  const { allNotificationSettings } = useNotifications();
  const { data, isLoading, isError } = allNotificationSettings;
  const { t } = useTranslation();

  const status = getPageStatus({ isLoading, isError });

  const action = status === 'ready' && !onboarding ? '/notifications' : 'back';

  return (
    <PageLayout
      status={status}
      headerBarProps={{
        title: t('notificationSettingsRegionAdd.title'),
        action,
      }}
    >
      {data && <Content regionSettings={data} onboarding={onboarding} />}
    </PageLayout>
  );
};
